import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'

export default function NotFoundPage() {
  return (
    <>
      <MetaTags
        title="Siden blev ikke fundet (404) - Trine Rosendal"
        description="Siden du leder efter findes desværre ikke eller er flyttet. Find vej tilbage til Trine Rosendals forside, behandlinger eller kontakt."
      />

      <div className="mx-auto max-w-3xl px-6 py-20 sm:py-28 text-center space-y-6">
        <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-[#E2EBD9] text-[#5C7A4F] text-2xl font-serif">
          404
        </div>

        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#222E1D]">
          Siden blev ikke fundet
        </h1>

        <p className="mx-auto max-w-md text-sm sm:text-base text-[#4D5E46] leading-relaxed">
          Siden du leder efter findes desværre ikke på denne adresse. Måske er linket udløbet eller stavet forkert.
        </p>

        <div className="pt-4 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full bg-[#5C7A4F] px-6 py-3 text-sm font-medium text-white shadow-xs hover:bg-[#455C3A] transition"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/behandlinger"
            className="inline-flex items-center gap-2 rounded-full border border-[#D6E2CB] bg-[#F7F9F3] px-6 py-3 text-sm font-medium text-[#222E1D] hover:bg-[#EAF1E4] transition"
          >
            <span>Se alle behandlinger</span>
          </Link>

          <a
            href="https://system.easypractice.net/book/online-booking-16"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-[#D6E2CB] bg-[#F7F9F3] px-6 py-3 text-sm font-medium text-[#222E1D] hover:bg-[#EAF1E4] transition"
          >
            <i className="fa-solid fa-calendar-check text-xs text-[#556B48]" aria-hidden="true" />
            <span>Book tid online</span>
          </a>

          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 rounded-full border border-[#D6E2CB] bg-[#F7F9F3] px-6 py-3 text-sm font-medium text-[#222E1D] hover:bg-[#EAF1E4] transition"
          >
            <span>Kontakt Trine</span>
          </Link>
        </div>
      </div>
    </>
  )
}
